// extracted by mini-css-extract-plugin
export default {"scroll-top":"ScrollTop_scroll-top__iqyhM","blind":"ScrollTop_blind__T69cT"};